package com.ervasstudio.tracoemovimento.components.sections

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.components.custumcomponents.SocialIcon
import com.ervasstudio.tracoemovimento.util.Res
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.graphics.Image
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

@Composable
fun HeaderDesktop(expandedItem: Int) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(top = 2.cssRem, leftRight = 1.cssRem).zIndex(9),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Image(
            modifier = Modifier.width(400.px).objectFit(ObjectFit.Cover),
            src = Res.Image.logo,
        )

        Row(verticalAlignment = Alignment.CenterVertically) {
            SocialIcon(
                src = if (expandedItem == 0 || expandedItem == 4) Res.Image.fblilas else Res.Image.fb,
                url = "https://www.facebook.com/profile.php?id=61581031844716",
                size = 60.px,
            )
            Box(Modifier.width(10.px))
            SocialIcon(
                src = if (expandedItem == 0) Res.Image.iglilas else Res.Image.ig,
                url = "https://www.instagram.com/traco_e_movimento/",
                size = 60.px,
            )
            Box(Modifier.width(10.px))
            SocialIcon(
                src = if (expandedItem == 0) Res.Image.ervaslogolilas else Res.Image.ervaslogo,
                url = "https://ervasstudio.com/",
                size = 60.px,
            )
        }
    }
}